import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import CustomToolTip from '../_tooltip';
import { tickValues, colourPalette, metricLegend, metricFormatFromId } from '../_base';
import { useSelector } from 'react-redux';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, item, id, front }) => {
    const values = data[0];
    const [leftTicks, setLeftTicks] = React.useState([]);
    const [leftTicksExtra, setLeftTicksExtra] = React.useState({});
    const [legend1, setLegend1] = React.useState('Metric');
    const [format1, setFormat1] = React.useState('Q');
    const [legend1Suffix, setLegend1Suffix] = React.useState('');

    const metrics = useSelector(state => state.dashboard.metrics);
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        let extra = {};
        setLeftTicks(tickValues(values, 'y', me.offsetHeight, true, extra));
        setLeftTicksExtra(extra);
    }, [item.h]);

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            if (parsed.metric1) {
                setLegend1(metricLegend(parsed.metric1, metrics, user.currencySymbol, legend1));
                setFormat1(metricFormatFromId(parsed.metric1, metrics));
            } else {
                setLegend1(SystemText('Dashboard/Widgets/SalesVelocity/Chart/Rating'));
            }
        }
    }, [values, item, metrics]);

    return (
        <ResponsiveBar
            data={data[0].map(d => ({ id: d.x, value: d.y }))}
            margin={{ top: 10, right: 60, bottom: 50, left: 60 }}
            valueFormat={x => `${user?.currencySymbol}${(x / 1000).toFixed()}k`}
            colors={{ scheme: 'nivo' }}
            padding={0.2}
            borderRadius={2}
            borderWidth={1}
            borderColor={{ from: 'color', modifiers: [['darker', '0.5']] }}
            axisTop={null}
            axisLeft={null}
            axisBottom={null}
            axisRight={{
                tickValues: leftTicks,
                format: x => (leftTicksExtra.format ? leftTicksExtra.format(x) : x),
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: `${legend1} ${legend1Suffix} ${leftTicksExtra.suffix ?? ''}`,
                legendPosition: 'middle',
                legendOffset: 40,
            }}
            enableGridY
            enableLabel={false}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            legends={[]}
            tooltip={point => (
                <CustomToolTip
                    point={point}
                    legend={legend1}
                    x="id"
                    y="value"
                    xFormat={x => e4Format(x, e4Formats.monthShort)}
                    yFormat={x => StringHelpers.formatMetric(format1, x, user.currencySymbol)}
                />
            )}
        />
    );
};

export default Chart;
